/**
 * Financial Table Tooltips
 *
 * @module
 */

import { up } from '../../utilities/QuerySelectors.js';
import { onDelegatedEvent } from '../../utilities/Events.js';
import { Tooltip } from '../reusable/Tooltip.js';
 
export class TableTooltips {
    /**
     * Display long values associated with a table cell in a popup box.
     */
    constructor() {
        this.tooltip = null;
        this.activeTooltip = null;
        this.activeButton = null;
    }

    /**
     * Initialize popup UI.
     *
     * @return {void}
     */
    init() {
        this.modalsContainer = document.getElementById('morningstar-modals');
        if (!this.modalsContainer) {
            return;
        }
        onDelegatedEvent('click', '.popup-btn', (e, button) => this.onButtonClick(button));
        this.modalsContainer.querySelector('.close-button').addEventListener('click', () => this.killActiveTooltip());
        // @ts-ignore
        document.addEventListener('click', e => this.checkForOutsideClick(e.target));
    }

    /**
     * Display the popup close to the given button.
     *
     * @private
     * @param {HTMLElement} button
     * @param {Tooltip} tooltip
     * @return {void}
     */
    show(button, tooltip) {
        tooltip.show(button, this.modalsContainer, () => {
            this.activeButton = button;
            button.classList.add('active');
            this.tooltip.modal.classList.add('active');
            setTimeout(() => this.modalsContainer.classList.add('active'), 16);
        });
        this.tooltip = tooltip;
        console.log('TableTooltips.show');
    }

    /**
     * Hide the currently displaying tooltip, if any.
     *
     * @private
     * @return {void}
     */
    killActiveTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltip.kill(this.modalsContainer);
        this.tooltip = null;

        this.activeButton = null;
        Array.from(this.modalsContainer.children).forEach(el => el.classList.remove('active'));
        this.modalsContainer.classList.remove('active');

        console.log('TableTooltips.killActiveTooltip');
    }

    /**
     * Show the tooltip belonging to the clicked button.
     *
     * @private
     * @param {HTMLElement} button
     * @return {void}
     */
    onButtonClick(button) {
        if (button === this.activeButton) {
            button.classList.remove('active');
            this.killActiveTooltip();
            return;
        }

        this.killActiveTooltip();

        const tooltip = new Tooltip(button.dataset.popup, up(button, 'tr'));
        tooltip.init();
        setTimeout(() => this.show(button, tooltip), 64);

        console.log('FinancialTableTooltips.onButtonClick', button);
    }

    /**
     * Close any active tooltip when the user clicks outside the tooltip UI.
     *
     * @private
     * @param {HTMLElement} clickedElement
     * @return {void}
     */
    checkForOutsideClick(clickedElement) {
        if (!this.modalsContainer.contains(clickedElement)) {
            this.killActiveTooltip();
        }
    }
}
